import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "./Ticket.css";
import "./menu3.css";
import { useNavigate } from "react-router-dom";
axios.defaults.withCredentials = true;

const NewTicket = () => {
  const [isAddressLoading, setIsAddressLoading] = useState(false);
  const [addressOptions, setAddressOptions] = useState([]);
  const [helpTopic, setHelpTopic] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [severityLevel, setSeverityLevel] = useState("");
  const [sla, setSla] = useState("Silver (5x8xNBD)");
  const [, setTickets] = useState([]);
  const [userDetails, setUserDetails] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const hasFetched = useRef(false);
  const [, setActiveMenu] = useState(2);
  const [formData, setFormData] = useState({
    email: "",
    fullName: "",
    position: "",
    phoneNumber: "",
    address: "",
    issueSummary: "",
    issueDetails: "",
    password: "",
    confirmPassword: "",
    fileupload: [],
    files: [],
    severityLevel: "",
    sla: "Platinum (7x24x4)",
  });
  const navigate = useNavigate();

 useEffect(() => {
  if (userDetails?.id && !hasFetched.current) {
    fetchTickets(userDetails.id);      
    hasFetched.current = true;
  }
}, [userDetails]);  

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await axios.get(
          "/customer/profile",
          {
            withCredentials: true,
          }
        );

        setUserDetails(response.data.user);
        setFormData((prevData) => ({
          ...prevData,
          email: response.data.user.email || "",
          fullName: response.data.user.name || "",
          phoneNumber: response.data.user.phone || "",
          position: response.data.user.position || "",
        }));
      } catch (err) {
        console.error("Error fetching user details:", err);
      }
    };
    fetchUserDetails();
  }, []);

  useEffect(() => {
    const fetchAddressOptions = async (email) => {
      setIsAddressLoading(true);
      try {
        const response = await fetch(
          `/ticketcustomer/getaddress?email=${encodeURIComponent(
            email
          )}`,
          {
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) throw new Error("Failed to fetch address options");
        const data = await response.json();
        const addresses = Array.isArray(data) ? data : [];
        setAddressOptions(addresses);
        setFormData((prevData) => ({ ...prevData, address: "" }));
      } catch (error) {
        console.error("Error fetching address options:", error);
        setAddressOptions([]);
      } finally {
        setIsAddressLoading(false);
      }
    };
    if (formData.email) fetchAddressOptions(formData.email);
  }, [formData.email]);

  const handleHelpTopicChange = (e) => {
    const selectedHelpTopic = e.target.value;
    setHelpTopic(selectedHelpTopic);
    setSeverityLevel(
      selectedHelpTopic === "Feedback and General Questions"
        ? "low"
        : selectedHelpTopic === "Report Hardware /Software System Down"
        ? "high"
        : "medium"
    );
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [id]: value }));
  };

  const handleFileChange2 = (event) => {
    const files = Array.from(event.target.files);
    if (files.length + selectedFiles.length > 7) {
      alert("คุณสามารถอัปโหลดไฟล์ได้ไม่เกิน 7 ไฟล์เท่านั้น");
    } else {
      setSelectedFiles((prev) => [...prev, ...files]);
    }
  };

const fetchTickets = async () => {
  try {
    const res = await fetch("/ticketcustomer", {
      method: "GET",
      credentials: "include",
      headers: { Accept: "application/json" },
    });

    if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);

    const data = await res.json().catch(() => []);
    setTickets(Array.isArray(data) ? data : []);
  } catch (err) {
    setTickets([]);
  }
};

useEffect(() => {
  if (!hasFetched.current) {
    fetchTickets();
    hasFetched.current = true;
  }
}, []);

  const submitForm = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    const phoneRegex = /^\d{10}$/;

    if (!emailRegex.test(formData.email)) {
      alert("Please enter a valid email.");
      setIsSubmitting(false);
      return;
    }
    if (!phoneRegex.test(formData.phoneNumber)) {
      alert("Please enter a 10-digit phone number.");
      setIsSubmitting(false);
      return;
    }
    if (
      !formData.address ||
      !helpTopic ||
      !formData.issueSummary.trim() ||
      !severityLevel ||
      !sla ||
      !formData.issueDetails.trim()
    ) {
      alert("Please fill in all fields.");
      setIsSubmitting(false);
      return;
    }

    const formDataObj = new FormData();
    formDataObj.append("id", userDetails.id);
    formDataObj.append("customer_address_id", formData.address);
    formDataObj.append("helpTopic", helpTopic);
    formDataObj.append("issueSummary", formData.issueSummary);
    formDataObj.append("severityLevel", severityLevel);
    formDataObj.append("sla", sla);
    formDataObj.append("issueDetails", formData.issueDetails);
    selectedFiles.forEach((file) => {
      formDataObj.append("attachedFiles", file);
    });

    try {
      const response = await fetch("/ticketcustomer", {
        method: "POST",
        credentials: "include",
        body: formDataObj,
      });

      if (!response.ok) {
        const contentType = response.headers.get("content-type");
        let errorText =
          contentType && contentType.includes("application/json")
            ? (await response.json()).message
            : await response.text();
        alert("An error occurred: " + errorText);
        return;
      }

      const responseData = await response.json();
      alert(
        `Ticket created successfully! Your ticket number is ${responseData.ticketNumber}`
      );
      await fetchTickets();
      resetForm();
      document.getElementById("fileupload").value = "";
      window.location.reload();
    } catch (error) {
      alert("An error occurred: " + error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setFormData({
      issueSummary: "",
      password: "",
      confirmPassword: "",
      issueDetails: "",
      severityLevel: "",
      sla: "",
      fileupload: [],
      files: [],
    });
    setHelpTopic("");
    setSelectedFiles([]);
  };

  const handleSeverityLevelsChange = (e) => {
    setSeverityLevel(e.target.value);
  };

  const handleMenuChange = (menuId) => {
    setActiveMenu(menuId);
    if (menuId === 1) {
      navigate("/tickets");
    }
  };

 const handleLogout = async () => {
    const ok = window.confirm("ยืนยันออกจากระบบ?");
    if (!ok) return;

    try {
      await axios.post("/customer/logout", {}, { withCredentials: true });
      // sessionStorage.clear();
      // localStorage.clear();

      navigate("/home"); 
    } catch (err) {
      console.error("Logout failed:", err);
      alert("ออกจากระบบไม่สำเร็จ");
    }
  };

  return (
    <div className="ticket-container">
      <div className="ticket-sidebar">
        <div className="ticket-menu-header">Menu</div>
        <ul className="ticket-menu-list">
          <li className="ticket-menu-item">
            <button
              className="ticket-button3"
              onClick={() => handleMenuChange(1)}
            >
              Ticket
            </button>
          </li>
          <li className="ticket-menu-item ticket-active">
            <button className="ticket-button3">Open a New Ticket</button>
          </li>
          <li className="ticket-menu-item">
            <button
              className="ticket-button3"
              onClick={() => {
                if (userDetails?.id) {
                  navigate("/setting");
                }
              }}
            >
              Setting
            </button>
          </li>
          <li className="ticket-menu-item">
              <button className="ticket-button3" onClick={handleLogout}>

              ออกจากระบบ
            </button>
          </li>
        </ul>
      </div>
      <div className="ticket-main-content">
        <div className="ticket-form-container">
          <h2>Open a New Ticket</h2>
          <p>Please fill in the form below to open a new ticket.</p>
          <div className="form-group">
            <label>Email :</label>
            <input type="email" id="email" value={formData.email} readOnly />
          </div>
          <div className="form-group">
            <label>Full Name:</label>
            <input
              type="text"
              id="fullName"
              value={formData.fullName}
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Phone Number:</label>
            <input
              type="text"
              id="phoneNumber"
              value={formData.phoneNumber}
              readOnly
            />
          </div>
          <div className="form-group">
            <label>Address:</label>
            {isAddressLoading ? (
              <div>Loading addresses...</div>
            ) : (
              <select
                id="address"
                value={formData.address || ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    address: Number(e.target.value),
                  }))
                }
                className="w-full p-2 border rounded mb-2"
              >
                <option value="" disabled>
                  -- โปรดเลือกที่อยู่ --
                </option>
                {addressOptions.map((address) => (
                  <option key={address.id} value={address.id}>
                    {address.address}
                  </option>
                ))}
              </select>
            )}
          </div>
          <div className="form-group">
            <label>Help Topic:</label>
            <select
              id="help-topic"
              value={helpTopic}
              onChange={handleHelpTopicChange}
              className="help-topic-select"
            >
              <option value="">Select a Help Topic</option>
              <option value="Feedback and General Questions">
                Feedback and General Questions
              </option>
              <option value="Report Hardware / Software Performamce Issue">
                Report Hardware / Software Performance Issue
              </option>
              <option value="Report Hardware /Software System Down">
                Report Hardware / Software System Down
              </option>
            </select>
          </div>
          {helpTopic && (
            <>
              <div className="form-group">
                <label>Issue Summary:</label>
                <input
                  type="text"
                  id="issueSummary"
                  name="issueSummary"
                  value={formData.issueSummary}
                  onChange={handleInputChange}
                  placeholder="Brief summary of your issue"
                />
              </div>
              <div className="form-group">
                <label>Severity Levels:</label>
                <select
                  id="Severity-Levels"
                  value={severityLevel}
                  onChange={handleSeverityLevelsChange}
                  className="help-topic-select no-arrow"
                  disabled
                >
                  <option value="low">Low</option>
                  <option value="medium">Medium</option>
                  <option value="high">High</option>
                </select>
              </div>
              <div className="form-group">
                <label>SLA:</label>
                <select
                  id="Sla"
                  value={sla}
                  onChange={(e) => setSla(e.target.value)}
                  className="help-topic-select"
                >
                  <option value="Silver (5x8xNBD)">Silver (5x8xNBD)</option>
                  <option value="Gold (7x24xNBD)">Gold (7x24xNBD)</option>
                  <option value="Platinum (7x24x4)">Platinum (7x24x4)</option>
                </select>
              </div>
              <div className="form-group">
                <label>Details:</label>
                <textarea
                  id="issueDetails"
                  name="issueDetails"
                  value={formData.issueDetails}
                  onChange={handleInputChange}
                  placeholder="Provide details about the issue"
                />
              </div>
              <div className="form-group">
                <label>Attach Files:</label>
                <input
                  type="file"
                  id="fileupload"
                  multiple
                  onChange={handleFileChange2}
                />
                <ul>
                  {selectedFiles.length > 0 ? (
                    selectedFiles.map((file, index) => (
                      <li key={index}>{file.name}</li>
                    ))
                  ) : (
                    <li>ยังไม่ได้เลือกไฟล์</li>
                  )}
                </ul>
              </div>
              <div className="form-actions">
                <button
                  onClick={submitForm}
                  className="submit-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Processing..." : "Create Ticket"}
                </button>
                <button onClick={resetForm} className="reset-button">
                  Reset
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewTicket;
